import React from "react";

const SeriesHeader = ({ title }) => {
  return (
    <div className='seriesHeader'>
      <h2 className='seriesTitle'>{title}</h2>
      <div className='seriesUnderline'></div>
    </div>
  );
};

export default SeriesHeader;
